import React from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import SideModal from "/src/components/modal/SideModal/SideModal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";

import CompanyModalBody from "./CompanyModalBody";

import "./CompanyModal.css";
import "/src/assets/css/polices.css";

const CompanyModal = NiceModal.create(({ title, data }) => {
    const modal = useModal();

    const { onClose } = useModalHelper(modal);
    const form = {
        id: data == undefined ? null : data.id,
        name: data == undefined ? null : data.name,
        title: title,
        logo: data == undefined ? null : data.logo,
        owner: data == undefined ? null : data.owner?.username,
        api_key_rag: data == undefined ? null : data.api_key_rag,
    };

    return (
        <SideModal name="change-password" id={modal.id} autoClose="true" onClose={onClose}>
            <div>
                <div
                    className="button-leave"
                    id="close_modal_container"
                    onClick={() => onClose({ idIconModal: "close_modal_container" })}>
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>

            <CompanyModalBody form={form}></CompanyModalBody>
        </SideModal>
    );
});

export default CompanyModal;
